import instance from "../../index";
import {Fleet} from "../../../models/fleet";
import {FleetFilter} from "../../../filters/fleet-filter";
import {PagedList} from "../../../models/paged-list";
import {BaseResponse} from "../../../models/base-response";
import {ShortDto} from "../../../models/short-dto";
import {CreateFleetRequest} from "../../../models/requests/create-fleet-request";
import {CreateDriverFleetRequest} from "../../../models/requests/create-driver-fleet-request";
import {DriverFleet} from "../../../models/requests/driver-fleet";
import {FleetDriverFilters} from "../../../filters/fleet-driver-filters";
import {UpdateFleetRequest} from "../../../models/requests/update-fleet-request";

export const useFleetService = () => {
    async function activeFleet(id: string): Promise<Fleet> {
        const response = await instance.put<Fleet>(`/v1/backoffice/fleets/${id}/active`);
        return response.data;
    }

    async function deactiveFleet(id: string): Promise<Fleet> {
        const response = await instance.put<Fleet>(`/v1/backoffice/fleets/${id}/deactive`);
        return response.data;
    }

    async function deleteFleet(id: string) {
        const response = await instance.delete(`/v1/backoffice/fleets/${id}`);
        return response?.data;
    }

    async function getFleetById(id: string): Promise<Fleet> {
        const response = await instance.get<BaseResponse<Fleet>>(`/v1/backoffice/fleets/${id}`);
        return response?.data?.data;
    }

    async function getFleets(filter?: FleetFilter): Promise<PagedList<Fleet>> {
        const response = await instance.get<PagedList<Fleet>>('/v1/backoffice/fleets/', {
            params: filter
        });
        return response?.data;
    }

    async function getAllFleetsShortDto(filter?: FleetFilter): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/fleets/all', {
            params: filter
        });
        return response?.data?.data;
    }

    async function createFleet(request: Partial<CreateFleetRequest>): Promise<Fleet> {
        const response = await instance.post<Fleet>(`/v1/backoffice/fleets/`, request);
        return response?.data;
    }

    async function editFleet(request: Partial<UpdateFleetRequest>, id: string | string [] | undefined): Promise<Fleet> {
        return (await instance.put<Fleet>(`/v1/backoffice/fleets/${id}`, request))?.data;
    }

    async function linkDriverFleet(request: Partial<CreateDriverFleetRequest>): Promise<DriverFleet> {
        const response = await instance.post<DriverFleet>(`/v1/backoffice/fleets/drivers`, request);
        return response?.data;
    }

    async function deleteDriverFleet(fleetId: string, driverId: string) {
        const response = await instance.delete(`/v1/backoffice/fleets/${fleetId}/driver/${driverId}`);
        return response?.data;
    }

    async function getFleetDrivers(filter?: FleetDriverFilters): Promise<PagedList<DriverFleet>> {
        const response = await instance.get<BaseResponse<PagedList<DriverFleet>>>(`/v1/backoffice/fleets/drivers`,
            {
                params: filter
            });
        return response.data.data;
    }

    return {
        activeFleet,
        deactiveFleet,
        deleteFleet,
        getFleetById,
        getFleets,
        getAllFleetsShortDto,
        createFleet,
        editFleet,
        linkDriverFleet: linkDriverFleet,
        deleteDriverFleet,
        getFleetDrivers
    }
}

export default useFleetService;